import { store } from "../store"

export const bootStorage = () => {
    store.dispatch.systemUser.boot();
    store.dispatch.alert.boot();
    store.dispatch.device.boot();
    store.dispatch.customer.boot();
    store.dispatch.eventMap.boot();
    store.dispatch.metrics.boot();
    store.dispatch.report.boot();
    store.dispatch.user.boot();
}